import React, { useState, useEffect, useMemo } from 'react'
import {
    Grid, Card, CardContent, DialogTitle, Button, Typography, DialogContentText, DialogContent,FormControl,FormLabel,InputLabel,Select,MenuItem,
    DialogActions,FormHelperText,
    Dialog,
    StepConnector,
    styled,Box,useMediaQuery
} from "@mui/material";
import Moment from 'moment';
import swal from "sweetalert";
import AuthUser from '../../../../Components/Auth/AuthUser';
import { fetchData,postFormData } from '../../../../redux/apiSlice';
import {  useDispatch } from 'react-redux';
import { CardOverflow } from '@mui/joy';
import { useParams } from 'react-router-dom';
import { TextareaAutosize } from '@mui/base';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';

function ActivityLog({activityLog,activityType,setActiveSection,cid,assetLink,type,viewActivity,getActivityLog}) {
     const dispatch = useDispatch();
    const {http,user} = AuthUser();
    const [companyId, setCompanyId] = React.useState(user.roles_id == 3 || user.roles_id == 4 || user.roles_id == 5 ? user.company_master_id : cid);
    const [open, setOpen] = React.useState(false);
    const [openAddNote, setOpenAddNote] = React.useState(false);
    const [maxWidth, setMaxWidth] = React.useState('sm');
    const [fullWidth, setFullWidth] = React.useState(true);
    const [freez, setFreez] = React.useState(false);
    const [files, setFiles] = useState([]);
    const isMobile = useMediaQuery('(max-width:600px)');
    const [serviceId, setServiceId] = useState();
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    const handleClose = () => {
        setOpen(false);
    };


    const handleCloseAddNote = () => {
        setOpenAddNote(false);
    };

    const activitySchema = Yup.object().shape({
        note: Yup.string()
            .required('Please Add Note'),
    });

    const handleBack = () =>{
        setActiveSection('services');
        getActivityLog();
    }

    const handleOpenViewFile = async(media_service_id) => {
        handleFreezStart();
        const folderName="assets"
        const apiUrl = `/viewFile/${companyId}/${media_service_id}/${folderName}`;
        const res = await dispatch(fetchData(apiUrl )).unwrap();
        if (res) {
            if (res.success == true) {
                setFiles(res.data);
                handleFreezStop();
            } else {
                handleFreezStop();
            }
        } else {
            swal({
                title: "Failed",
                text: "Network Error",
                icon: "error",
                button: "Ok",
            });
        }
        setOpen(true);
    };

    const handleOpenAddNote = async(media_service_id) => {
        setServiceId(media_service_id);
        setOpenAddNote(true);
    };
    return (
        <>
        {
            activityLog.id?
            <>
            <Grid container item lg={12} md={12} sm={12} xs={12} mb={1} mt={2}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Typography><b>Service Name:</b></Typography>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Typography><b>{activityType}</b></Typography>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Typography><b>Assigned Person:</b></Typography>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Typography><b>{activityLog.assigned_to}</b></Typography>
                        </Grid>
                    </Grid>
                </Grid>
                
                    <Grid item lg={6} md={6} sm={12} xs={12} display={"flex"} justifyContent={"right"}>
                        {
                            assetLink != null ?
                            <Button variant="contained" sx={{ backgroundColor: '#2E67BC', fontWeight: 'bold', borderRadius: '10px', textTransform: "capitalize" }}
                                onClick={() => handleOpenViewFile(activityLog.media_service_id)}>
                                View Assets</Button>
                        : ''
                        }   
                        {
                        user.roles_id == 1 || user.roles_id == 2 || user.roles_id == 15 ?
                        <Button variant="contained" sx={{ backgroundColor: '#2E67BC', fontWeight: 'bold', borderRadius: '10px', textTransform: "capitalize",marginLeft:'10px' }}
                            onClick={() => handleOpenAddNote(activityLog.id)}>
                            Add Note</Button> 
                            : ''
                        }
                      
                    </Grid> 
            </Grid>
            <Grid container item lg={12} md={12} sm={12} xs={12} >
                {
                    activityLog.logs.map((log, index) => (
                    <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
                    <Card variant='outlined' sx={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%', borderRadius: "10px" }}>
                        <CardContent>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Grid item lg={4} md={4} sm={5} xs={5}>
                                    <Typography variant={isMobile?"body2":'body1'}><b>Last Follow up By:</b></Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={7} xs={7}>
                                    <Typography variant={isMobile?"body2":'body1'} sx={{ textAlign: "right" }}>{log.user.first_name + " " +log.user.last_name}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Grid item lg={4} md={4} sm={6} xs={6}>
                                    <Typography variant={isMobile?"body2":'body1'}><b>Last Follow up date:</b></Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={6} xs={6}>
                                    <Typography variant={isMobile?"body2":'body1'} sx={{ textAlign: "right" }}> {Moment(log.created_at).tz('America/Los_Angeles').format('MM-DD-YYYY H:mm')} </Typography>
                                </Grid>
                            </Grid>
                            {/* <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Grid item lg={4} md={4} sm={4} xs={4}>
                                    <Typography><b>Reply date & time:</b></Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                    <Typography sx={{ textAlign: "right" }}>05-27-2025 05:07Hrs</Typography>
                                </Grid>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Grid item lg={4} md={4} sm={4} xs={4}>
                                    <Typography><b>Reply by:</b></Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                    <Typography sx={{ textAlign: "right" }}>Assigned person name</Typography>
                                </Grid>
                            </Grid> */}
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Grid item lg={4} md={4} sm={5} xs={5}>
                                    <Typography variant={isMobile?"body2":'body1'}><b>Event </b></Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={7} xs={7}>
                                    <Typography variant={isMobile?"body2":'body1'} sx={{ textAlign: "right" }}>{log.event_type}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} mt={1}>
                                    <Typography variant={isMobile?"body2":'body1'}><b>Comment </b> {log.comment ? log.comment : 'N/A'}</Typography>
                            </Grid>
                            {/* <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Grid item lg={4} md={4} sm={4} xs={4}>
                                    <Typography><b>Description by Expert assigned:</b></Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                    <Typography>lorem ipsum Testlorem ipsum Testlorem ipsum Testlorem ipsum Testlorem ipsum Testlorem ipsum Test</Typography>
                                </Grid>
                            </Grid> */}

                        </CardContent>
                    </Card>
                    </Grid>
                    ))
                }
                
               
                {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Card variant='outlined' sx={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%', borderRadius: "10px" }}>
                        <CardContent>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Grid item lg={4} md={4} sm={4} xs={4}>
                                    <Typography><b>Last Follow up By:</b></Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                    <Typography sx={{ textAlign: "right" }}>Affiliate Name</Typography>
                                </Grid>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Grid item lg={4} md={4} sm={4} xs={4}>
                                    <Typography><b>Last Follow up date:</b></Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                    <Typography sx={{ textAlign: "right" }}>05-06-2025 04:07Hrs</Typography>
                                </Grid>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Grid item lg={4} md={4} sm={4} xs={4}>
                                    <Typography><b>Reply date & time:</b></Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                    <Typography sx={{ textAlign: "right" }}>05-27-2025 05:07Hrs</Typography>
                                </Grid>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Grid item lg={4} md={4} sm={4} xs={4}>
                                    <Typography><b>Reply by:</b></Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                    <Typography sx={{ textAlign: "right" }}>Assigned person name</Typography>
                                </Grid>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Grid item lg={4} md={4} sm={4} xs={4}>
                                    <Typography><b>Description by Affiliate:</b></Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                    <Typography>lorem ipsum Testlorem ipsum Testlorem ipsum Testlorem ipsum Testlorem ipsum Testlorem ipsum Test</Typography>
                                </Grid>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Grid item lg={4} md={4} sm={4} xs={4}>
                                    <Typography><b>Description by Expert assigned:</b></Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                    <Typography>lorem ipsum Testlorem ipsum Testlorem ipsum Testlorem ipsum Testlorem ipsum Testlorem ipsum Test</Typography>
                                </Grid>
                            </Grid>

                        </CardContent>
                    </Card>
                </Grid> */}
            </Grid>
            <Grid container item lg={12} md={12} sm={12} xs={12} mt={2} >
                <Button variant="outlined" sx={{ fontWeight: 'bold', borderRadius: '10px', minWidth: 150 }} onClick={() => handleBack()}>
                    Back</Button>
            </Grid>
            </>
            :''
        }
            
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{padding:"2%"}}
                 fullWidth={fullWidth}
                maxWidth={maxWidth}
            >
                
                <Card>
                    <CardOverflow
                        sx={{
                            bgcolor:'#2E67BC',
                            borderColor:'#2E67BC',
                            padding: '1%',
                        }}
                    >
                        <Grid item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"right"}>
                                <Button onClick={handleClose}><img src={require('../../../../assets/images/closeWhite.png')} /></Button>
                            </Grid>
                    </CardOverflow>
                    <CardContent sx={{height:"400px",overflowY:"scroll"}}> 
                        <Grid container spacing={2} mt={2}>
                            {files.length === 0 ? (
                            <Grid item xs={12}>
                                <Typography>No files found.</Typography>
                            </Grid>
                            ) : (
                            files.map((file) => {
                                const name = file.name.toLowerCase();
                                const isVideo = name.endsWith(".mp4");
                                const isImage = /\.(jpg|jpeg|png|gif)$/i.test(name);

                                return (
                                <Grid
                                    item
                                    key={file.id || file.path_lower}
                                    xs={12}
                                    sx={{ display: "flex", justifyContent: "center" }}
                                >
                                    {isVideo ? (
                                    <video
                                        width={isMobile ? "100%" : "250px"}
                                        controls
                                        src={file.temporary_link}
                                        style={{
                                        borderRadius: 4,
                                        marginTop: isMobile ? "1%" : "3%",
                                        }}
                                    >
                                        Your browser does not support the video tag.
                                    </video>
                                    ) : isImage ? (
                                    <img
                                        src={file.temporary_link}
                                        alt={file.name}
                                        style={{
                                        width: isMobile ? "100%" : "250px",
                                        height: "auto",
                                        borderRadius: 4,
                                        objectFit: "cover",
                                        }}
                                    />
                                    ) : null}
                                </Grid>
                                );
                            })
                            )}
                        </Grid>
                    </CardContent>
                </Card>
            </Dialog>

           <Formik
                initialValues={{
                    serviceId: serviceId,
                    note: '',
                }}
                validationSchema={activitySchema}
                onSubmit={async(values,{ resetForm }) => { 
                    const apiUrl = '/addNoteByAdmin';
                    setOpenAddNote(false);
                    handleFreezStart();
                    const formData = new FormData();
                    formData.append('serviceId', serviceId);
                    formData.append('note', values.note);
                    formData.append('mediaType', type);

                    const res = await dispatch(postFormData({apiUrl,formData})).unwrap();
                    if(res) {
                        
                        if(res.success === true){
                            swal({
                                title: "Success",
                                text: res.message,
                                icon: "success",
                                button: "Ok",
                            })
                            
                            viewActivity(serviceId,type);
                        }else{
                            
                            handleFreezStop();
                            swal({
                                title: "Failed",
                                text: res.message,
                                icon: "error",
                                button: "Ok",
                            })
                            if(res.message == "This action is unauthorized.") {
                                // navigate('/login');
                            }
                            
                        }
                        resetForm();
                    }
                }}
            >
                {({values,errors,touched,isSubmitting,handleChange,handleBlur,handleSubmit,setFieldValue,resetForm}) =>(
                    <Dialog
                        maxWidth={maxWidth}
                        fullWidth={fullWidth}
                        disableEscapeKeyDown={true}
                        open={openAddNote}
                        onClose={(_, reason) => {
                            if (reason !== "backdropClick") {
                                handleCloseAddNote();
                            }
                        }}                           
                        aria-labelledby="responsive-dialog-title"
                        >
                        <DialogTitle textAlign={'center'} id="responsive-dialog-title" sx={{backgroundColor:"#F6FAFF"}}>
                            <Typography level="h4" color='primary'>Add Note</Typography>
                        </DialogTitle>
                        <Form>
                        <DialogContent>
                            <Box mt={1}>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>                                                                      
                                    <Grid container item lg={12} md={12} sm={12} xs={12} mt={1} id="note">
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <FormLabel>Note*</FormLabel>
                                            <FormControl fullWidth size="small"
                                                error={touched.note && errors.note ? errors.note : ''}
                                            > 
                                                <TextareaAutosize
                                                    aria-label="minimum height"
                                                    minRows={5}
                                                    placeholder="Note"
                                                    fullWidth
                                                    name="note"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.note}
                                                />
                                                <FormHelperText>{touched.note && errors.note ? errors.note : ''}</FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> 
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Grid container item lg={12} md={12} sm={12} xs={12} sx={{textAlign:"center",width:"100%"}}>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <Button  autoFocus variant="contained" sx={{minWidth:150}} 
                                    onClick={(e)=>{
                                        // handleClose(resetForm);
                                        handleCloseAddNote();
                                    }}>
                                        CLOSE
                                    </Button>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <Button variant="contained" sx={{minWidth:150}} color="success" type="submit" onClick={handleSubmit} disabled={ (isSubmitting) }>
                                        SAVE
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                        </Form>
                    </Dialog>

                )}

            </Formik>
        </>
    )
}
export default ActivityLog;